import { render, staticRenderFns } from "./addnewuser.vue?vue&type=template&id=604bc94c&scoped=true&"
import script from "./addnewuser.vue?vue&type=script&lang=js&"
export * from "./addnewuser.vue?vue&type=script&lang=js&"
import style0 from "./addnewuser.vue?vue&type=style&index=0&id=604bc94c&lang=scss&scoped=true&"
import style1 from "./addnewuser.vue?vue&type=style&index=1&id=604bc94c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604bc94c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VCard,VDivider,VForm,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
